const memoizeDndCollect = (collect) => {
  let values = {};

  return (monitor) => {
    const newValues = collect(monitor);

    if (Object.entries(newValues).some(([k, v]) => values[k] !== v)) {
      values = newValues;
    }

    return values;
  };
};

export default memoizeDndCollect;
